export default {
  namespaced: true,
  state: {
    title: '',
    focusMode: false,
    loading: false,
    globalMessages: [],
    showHeader: true,
    locales: [
      {
        key: 'en-US',
        text: 'English (U.S.)',
      },
    ],
    navMenu: {
      enabled: false,
      open: false,
    },
    breadcrumbItems: [],
  },
  mutations: {
    set (state, payload) {
      payload(state);
    },
  },
};
